import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import checkErrors from "Utils/InputValidator";
import STRINGS from "../Constants/Strings";
import VALIDATIONS from "../Constants/ValidationList";
import FIInformation from "../Constants/FIInformation";
import MODALMESSAGES from "../Constants/Messages";
import PopupModal from "../Components/Common/PopupModal/PopupModal";
import AppConstants from "../Constants/AppConstants";
import { S_ACCOUNT_ID, S_STAFF_ID } from "../Communication/Constants";

export function BranchRegister(props) {
  // Form state
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [hasMobile, setHasMobile] = useState(null);
  const [mobile, setMobile] = useState("");
  const [mobileOnHand, setMobileOnHand] = useState(null);
  const [homePhone, setHomePhone] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState({});
  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState("");

  // Email validation function to allow only valid email characters
  const filterEmailCharacters = (value) =>
    // Allow letters, numbers, dots, hyphens, underscores, plus signs, and @ symbol
    value.replace(/[^a-zA-Z0-9@._+-]/g, "");

  // Mobile number validation function to allow only numeric characters
  const filterNumericCharacters = (value) =>
    // Allow only digits (0-9)
    value.replace(/[^0-9]/g, "");

  const verifyData = () => {
    let formIsValid = true;
    console.log(
      "Verifying data...",
      email,
      confirmEmail,
      hasMobile,
      mobile,
      mobileOnHand,
      homePhone
    );
    const emailRes = checkErrors(email, VALIDATIONS.REGISTRATION.email);
    console.log("emailRes", emailRes);
    if (emailRes && emailRes.length > 0) {
      setError((prev) => ({ ...prev, email: emailRes }));
      formIsValid = false;
    } else {
      const confirmEmailRes = checkErrors(
        confirmEmail,
        VALIDATIONS.REGISTRATION.email
      );
      console.log("confirmEmailRes", confirmEmailRes);
      if (email !== confirmEmail && confirmEmailRes.length === 0) {
        confirmEmailRes.push(STRINGS.REGISTRATION.ERROR.EMAIL_DO_NOT_MATCH);
      }
      if (confirmEmailRes.length > 0) {
        setError((prev) => ({ ...prev, confirmEmail: confirmEmailRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, confirmEmail: null }));
      }
    }

    if (hasMobile === null) {
      setError((prev) => ({
        ...prev,
        hasMobile: STRINGS.REGISTRATION.ERROR.HAS_MOBILE_REQUIRED,
      }));
      formIsValid = false;
    } else {
      setError((prev) => ({ ...prev, hasMobile: null }));
    }

    if (hasMobile === true) {
      if (mobileOnHand === null) {
        setError((prev) => ({
          ...prev,
          mobileOnHand: STRINGS.REGISTRATION.ERROR.MOBILE_ON_HAND,
        }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, mobileOnHand: null }));
      }

      const mobileRes = checkErrors(
        mobile,
        VALIDATIONS.REGISTRATION.BRANCH.MOBILE_NO
      );
      console.log("mobileRes", mobileRes, mobile);
      if (mobileRes && mobileRes.length > 0) {
        setError((prev) => ({ ...prev, mobile: mobileRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, mobile: null }));
      }
    } else if (hasMobile === false) {
      const homePhoneRes = checkErrors(
        homePhone,
        VALIDATIONS.REGISTRATION.BRANCH.HOME_PHONE
      );
      if (homePhoneRes && homePhoneRes.length > 0) {
        setError((prev) => ({ ...prev, homePhone: homePhoneRes }));
        formIsValid = false;
      } else {
        setError((prev) => ({ ...prev, homePhone: null }));
      }
    } else {
      setError((prev) => ({ ...prev, mobile: null, homePhone: null }));
    }

    const termscondition = checkErrors(
      isChecked || "",
      VALIDATIONS.REGISTRATION.termscondition
    );

    if (termscondition && termscondition.length > 0) {
      setError((prev) => ({ ...prev, isChecked: termscondition }));
      formIsValid = false;
    } else {
      setError((prev) => ({ ...prev, isChecked: null }));
    }

    return formIsValid;
  };
  // Registration function to handle form submission
  const register = (e) => {
    e.preventDefault();

    // Reset error state before validation

    setError({});

    const {
      doCheckExistingUser,
      doRegistration,
      doVerification,
      bankingType,
    } = props;
    if (verifyData()) {
      // Handle form submission logic here
      console.log("Form submitted with:", {
        email,
        confirmEmail,
        hasMobile,
        mobile,
        mobileOnHand,
      });
      doCheckExistingUser(
        {
          credential: email,
          bankingType,
        },
        (response) => {
          console.log("Existing user check response:", response);
          if (response && response.data && response.data.existing) {
            setShowError(true);
            setErrorText(MODALMESSAGES.REGISTRATION.BRANCH.EXISTING_USER_ERROR);
          } else {
            // Proceed with registration if user does not exist
            doRegistration(
              {
                email,
                confirm: confirmEmail,
                hasMobile,
                msisdn: mobile ? `1${mobile}` : "",
                mobileOnHand,
                homePhone,
                otpTo: mobileOnHand ? "msisdn" : "email",
                bankingType: bankingType || AppConstants.BANKING_TYPE.PERSONAL,
                staffId: sessionStorage.getItem(S_STAFF_ID) || "",
              },
              (registrationResponse) => {
                console.log("Registration response:", registrationResponse);
                doVerification(registrationResponse.data);
                setShowError(false);
                setErrorText("");
                // Handle successful registration response here
              },
              (errorResponse) => {
                console.error("Registration error:", errorResponse);
                setShowError(true);
                setErrorText(
                  errorResponse.message ||
                    "An error occurred during registration."
                );
              }
            );
          }
        }
      );
    }
  };

  // Registration form (left column)
  const registrationForm = (
    <Card style={{ border: 0, minHeight: "90%" }}>
      <Card.Header
        style={{
          background: "#206080",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.2em",
          display: "flex",
          alignItems: "center",
        }}
      >
        <i className="fas fa-user-plus me-2" style={{ marginRight: 8 }} />
        PERSONAL MEMBER REGISTRATION
      </Card.Header>
      <Card.Body style={{ background: "#fff", padding: 24 }}>
        <form>
          <div className="[ mb-3 ]">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="form-control"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => {
                setEmail(filterEmailCharacters(e.target.value));
                setError((prev) => ({ ...prev, email: null }));
              }}
              autoComplete="off"
            />
            <div className="[ error-msg ]">
              <span>
                {error.email && error.email[0] === "Enter valid email address"
                  ? "Enter a valid email address"
                  : error.email?.[0] || null}
              </span>
            </div>
          </div>
          <div className="[ mb-3 ]">
            <label htmlFor="confirmEmail" className="form-label">
              Confirm Email
            </label>
            <input
              id="confirmEmail"
              type="email"
              className="form-control"
              placeholder="Enter email address"
              value={confirmEmail}
              onChange={(e) => {
                setConfirmEmail(filterEmailCharacters(e.target.value));
                setError((prev) => ({ ...prev, confirmEmail: null }));
              }}
              autoComplete="off"
            />
            <div className="[ error-msg ]">
              <span>{error.confirmEmail ? error.confirmEmail[0] : null}</span>
            </div>
          </div>
          <div className="[ mb-3 ]">
            <fieldset style={{ border: 0, padding: 0, margin: 0 }}>
              <legend
                style={{ fontSize: "1rem", fontWeight: 500, marginBottom: 8 }}
              >
                Does this customer have a mobile phone number?
              </legend>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  id="hasMobile-yes"
                  className={`[ btn ] [ w-100 ] ${
                    hasMobile && typeof hasMobile === "boolean"
                      ? "btn-dark"
                      : "btn-outline-light"
                  }`}
                  style={{
                    border: "1px solid #cdcdcd",
                    minWidth: 120,
                    fontWeight: 600,
                    color:
                      hasMobile && typeof hasMobile === "boolean"
                        ? undefined
                        : "#222",
                    marginRight: 15,
                  }}
                  onClick={() => {
                    setHasMobile(true);
                    setError((prev) => ({ ...prev, hasMobile: null }));
                    setHomePhone(""); // Reset home phone if switching to mobile
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  id="hasMobile-no"
                  className={`[ btn ] [ w-100 ] ${
                    !hasMobile && typeof hasMobile === "boolean"
                      ? "btn-dark"
                      : "btn-outline-light"
                  }`}
                  style={{
                    border: "1px solid #cdcdcd",
                    minWidth: 120,
                    fontWeight: 600,
                    color:
                      !hasMobile && typeof hasMobile === "boolean"
                        ? undefined
                        : "#222",
                  }}
                  onClick={() => {
                    setHasMobile(false);
                    setError((prev) => ({ ...prev, hasMobile: null }));
                    setMobile(""); // Reset mobile if switching to home phone
                  }}
                >
                  No
                </button>
              </div>
              <div className="[ error-msg ]">
                <span>{error.hasMobile ? error.hasMobile : null}</span>
              </div>
            </fieldset>
          </div>
          {hasMobile === true && (
            <div
              style={{
                background: "#f7f7f7",
                borderRadius: 8,
                padding: 24,
                marginBottom: 16,
              }}
            >
              <div className="mb-3">
                <label htmlFor="mobile" className="form-label">
                  Enter Mobile no.
                </label>
                <input
                  id="mobile"
                  type="text"
                  className="form-control"
                  placeholder="Enter 10 digit mobile number"
                  aria-label="Enter mobile no."
                  value={mobile}
                  onChange={(e) => {
                    setMobile(filterNumericCharacters(e.target.value));
                    setError((prev) => ({ ...prev, mobile: null }));
                  }}
                  autoComplete="off"
                  maxLength={10}
                />
                <div className="[ error-msg ]">
                  <span>{error.mobile ? error.mobile[0] : null}</span>
                </div>
              </div>
              <div className="mb-3">
                <fieldset style={{ border: 0, padding: 0, margin: 0 }}>
                  <legend
                    style={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      marginBottom: 8,
                    }}
                  >
                    Does this customer have their mobile on them right now?
                  </legend>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      id="mobileOnHand-yes"
                      className={`[ btn ] [ w-100 ] ${
                        mobileOnHand && typeof mobileOnHand === "boolean"
                          ? "btn-dark"
                          : "btn-outline-light"
                      }`}
                      style={{
                        border: "1px solid #cdcdcd",
                        minWidth: 120,
                        fontWeight: 600,
                        color:
                          mobileOnHand && typeof mobileOnHand === "boolean"
                            ? undefined
                            : "#222",
                        marginRight: 15,
                      }}
                      onClick={() => {
                        setMobileOnHand(true);
                        setError((prev) => ({ ...prev, mobileOnHand: null }));
                      }}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      id="mobileOnHand-no"
                      className={`[ btn ] [ w-100 ] ${
                        mobileOnHand === false &&
                        typeof mobileOnHand === "boolean"
                          ? "btn-dark"
                          : "btn-outline-light"
                      }`}
                      style={{
                        border: "1px solid #cdcdcd",
                        minWidth: 120,
                        fontWeight: 600,
                        color:
                          mobileOnHand === false &&
                          typeof mobileOnHand === "boolean"
                            ? undefined
                            : "#222",
                      }}
                      onClick={() => {
                        setMobileOnHand(false);
                        setError((prev) => ({ ...prev, mobileOnHand: null }));
                      }}
                    >
                      No
                    </button>
                  </div>
                  <div className="[ error-msg ]">
                    <span>{error.mobileOnHand}</span>
                  </div>
                </fieldset>
              </div>
              {typeof mobileOnHand === "boolean" && (
                <div className="mb-3">
                  <div
                    style={{
                      background: "#eaf6ff",
                      border: "1.5px solid #8ec6f7",
                      borderRadius: 4,
                      padding: 12,
                      color: "#206080",
                      fontSize: 14,
                    }}
                  >
                    {mobileOnHand && (
                      <>
                        <div>
                          Inform the customer that in the next step a one time
                          verification code will be sent to their mobile. They
                          will report back this verification code to you for
                          them to be able to complete their smartOpen
                          registration.
                        </div>
                        <div style={{ marginTop: 8 }}>
                          Inform the customer that in the future, when they use
                          the smartOpen application for their first time, a one
                          time verification code will be sent to their mobile
                          phone for them to set their own password.
                        </div>
                      </>
                    )}
                    {!mobileOnHand && (
                      <>
                        <div>
                          Inform the customer that in the future, when they use
                          the smartOpen application for their first time, a one
                          time verification code will be sent to their mobile
                          phone for them to set their own password.
                        </div>
                        <div style={{ marginTop: 8 }}>
                          In the future, one time verification codes will be
                          sent to their mobile number for their convenience.
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          {hasMobile === false && (
            <div
              style={{
                background: "#f7f7f7",
                borderRadius: 8,
                padding: 24,
                marginBottom: 16,
              }}
            >
              <div className="mb-3">
                <label htmlFor="homePhone" className="form-label">
                  Enter home phone no.
                </label>
                <input
                  id="homePhone"
                  type="text"
                  className="form-control"
                  placeholder="Enter 10 digit home number"
                  aria-label="Enter home phone no."
                  value={homePhone}
                  onChange={(e) => {
                    setHomePhone(filterNumericCharacters(e.target.value));
                    setError((prev) => ({ ...prev, homePhone: null }));
                  }}
                  autoComplete="off"
                  maxLength={10}
                />
                <div className="[ error-msg ]">
                  <span>{error.homePhone ? error.homePhone[0] : null}</span>
                </div>
              </div>
              <div className="mb-3">
                <div
                  style={{
                    background: "#eaf6ff",
                    border: "1.5px solid #8ec6f7",
                    borderRadius: 4,
                    padding: 12,
                    color: "#206080",
                    fontSize: 14,
                  }}
                >
                  <div>
                    Inform the customer that in the future, when they use the
                    smartOpen application for their first time, an email
                    containing a one time link will be sent to their email for
                    them to be able to set their own password.
                  </div>
                  <div style={{ marginTop: 8 }}>
                    In the future, one time verification codes will be sent to
                    their email address on file for their convenience.
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="[ row ] [ align-items-center ]">
            <div className="[ col-12 ] [ d-flex align-items-center ]">
              <div className=" [ checkbox custom-control custom-checkbox ]">
                <input
                  type="checkbox"
                  defaultChecked={isChecked}
                  onChange={(e) => {
                    setIsChecked(e.target.checked);
                    setError((prev) => ({ ...prev, isChecked: null }));
                  }}
                  name="termscondition"
                  id="termsCheckbox"
                  className={
                    error.isChecked
                      ? "[ invalid-input ] [ custom-control-input ]"
                      : "[ custom-control-input ]"
                  }
                />
                <label
                  htmlFor="termsCheckbox"
                  className="[ custom-control-label ]"
                >
                  <span className="[ form-checkbox__text ]">
                    {STRINGS.REGISTRATION.FORM.TERMSLABEL1}
                    <a
                      href={FIInformation.FI_CONDITIONS}
                      className="[ text-primary ]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {STRINGS.REGISTRATION.FORM.TERMSLABEL2}
                    </a>
                    {STRINGS.REGISTRATION.FORM.TERMSLABEL3}
                  </span>
                </label>
              </div>
            </div>

            <div className="[ error-msg ] [ col-12 ]">
              {error.isChecked ? MODALMESSAGES.REGISTRATION.TERMSERROR : ""}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              marginTop: 24,
            }}
          >
            <button
              type="submit"
              style={{
                width: "50%",
                background: isHover ? "#199be6" : "#38b6ff",
                color: "#fff",
                fontWeight: 700,
                fontSize: 20,
                border: "1.5px solid #38b6ff",
                borderRadius: 6,
                padding: "12px 0",
                marginTop: 16,
                letterSpacing: 1,
                textTransform: "uppercase",
                boxShadow: "none",
                outline: "none",
                transition: "background 0.2s",
              }}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              onClick={register}
            >
              CONTINUE
            </button>
          </div>
        </form>
      </Card.Body>
    </Card>
  );

  // Info panel (center column)
  const infoPanel = (
    <Card style={{ border: 0, minHeight: "90%" }}>
      <Card.Header
        style={{
          background: "#206080",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.2em",
        }}
      >
        &nbsp;
      </Card.Header>
      <Card.Body
        style={{ background: "#fff", padding: 32, textAlign: "center" }}
      >
        <div style={{ fontWeight: 600, fontSize: "1.3em", marginBottom: 16 }}>
          In this step
        </div>
        <div style={{ fontSize: 16, color: "#222" }}>
          Register your customer&#39;s smartOpen profile.
          <br />
          <br />
          Inform your customer that once they are registered, they will have the
          ability to begin, continue or complete applications either in-branch
          or at their convenience from home or on the go.
          <br />
          <br />
          Inform them that they will have the ability to be able to start an
          application remotely and finish in branch or vice versa.
        </div>
      </Card.Body>
    </Card>
  );

  // Personal cart (right column)
  const cartPanel = (
    <Card style={{ border: 0, minHeight: "90%" }}>
      <Card.Header
        style={{
          background: "#206080",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.2em",
          display: "flex",
          alignItems: "center",
        }}
      >
        <i className="fas fa-shopping-cart me-2" style={{ marginRight: 8 }} />
        Personal Cart
      </Card.Header>
      <Card.Body
        style={{
          background: "#fff",
          padding: 32,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 16, color: "#222", marginBottom: 16 }}>
          &quot;0&quot; item(s) in your cart
        </div>
        <div style={{ color: "#888", marginBottom: 24, textAlign: "center" }}>
          Add financial products from the marketplace to your cart.
        </div>
        <button
          type="button"
          className="btn btn-lg btn-outline-secondary"
          style={{ minWidth: 180, fontWeight: 600 }}
          disabled
          onClick={register}
        >
          PROCEED
        </button>
      </Card.Body>
    </Card>
  );

  return (
    <div className="[ branch-wrapper ]">
      {showError && (
        <PopupModal
          type={AppConstants.MODALTYPE.FAILURE}
          title={errorText}
          toggleModal={() => setShowError(false)}
          showModal={showError}
          btnText={STRINGS.POPUPMODAL.OKBUTTON}
        />
      )}
      <div className="[ container ] [ pb-3 ] [ main-container ]">
        <div className="[ row ] [ main-container__body ]">
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-12"
            style={{ background: "#f7f7f7" }}
          >
            <div className="row" style={{ height: "100%", minHeight: "90vh" }}>
              <div className="col-xl-6 col-lg-12" style={{ marginBottom: 24 }}>
                {registrationForm}
              </div>
              <div className="col-xl-3 col-lg-12" style={{ marginBottom: 24 }}>
                {infoPanel}
              </div>
              <div className="col-xl-3 col-lg-12" style={{ marginBottom: 24 }}>
                {cartPanel}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

BranchRegister.propTypes = {
  doCheckExistingUser: PropTypes.func.isRequired,
  doRegistration: PropTypes.func.isRequired,
  doVerification: PropTypes.func.isRequired,
  bankingType: PropTypes.string, // Specify the correct PropTypes type if known
};

BranchRegister.defaultProps = {
  bankingType: AppConstants.BANKING_TYPE.PERSONAL, // Default value for bankingType
};

export default BranchRegister;
